import {
    ApplicationConfig,
    importProvidersFrom,
    mergeApplicationConfig,
} from '@angular/core';
import {
    InMemoryScrollingFeature, InMemoryScrollingOptions,
    provideRouter, withEnabledBlockingInitialNavigation,
    withInMemoryScrolling,
} from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {HttpClient, provideHttpClient, withFetch} from "@angular/common/http";
import {TranslateModule} from "@ngx-translate/core";
import {provideStore} from "@ngrx/store";
import {ToastrModule} from "ngx-toastr";
import {provideTranslation} from "@cybfed/core/config/i18n";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
const scrollConfig: InMemoryScrollingOptions = {
    scrollPositionRestoration: 'top',
    anchorScrolling: 'enabled',
};
export function createTranslateLoader(http: HttpClient) : TranslateHttpLoader {
    return new TranslateHttpLoader(http, '/assets/i18n/whiteLabel/', '.json');
}

const inMemoryScrollingFeature: InMemoryScrollingFeature =
    withInMemoryScrolling(scrollConfig);
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, inMemoryScrollingFeature),
    provideAnimationsAsync(),
    provideStore(),
    provideHttpClient(withFetch()),
    importProvidersFrom(
        TranslateModule.forRoot(provideTranslation(createTranslateLoader)),
        ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }),), provideClientHydration()
  ]
}
